<template>
  <v-dialog :value="value" persistent @input="input => $emit('input', input)" :width="advanced ? 1000 : 450">
    <v-card class="pa-3 pb-10">
      <div class="d-flex justify-end">
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="d-flex justify-center pt-5 pb-5">
        <div :style="advanced && 'width: 40%;'" class="d-flex flex-column align-center">
          <div class="d-flex flex-column align-center">
            <h3>Faça o download do QR Code</h3>

            <v-select
              style="width: 250px;"
              class="mt-5"
              dense
              v-model="format"
              label="Escolha o formato"
              :items="['SVG', 'PNG', 'JPEG', 'WEBP']"
              outlined
              hide-details
            ></v-select>

            <div class="mt-5" id="qr-code" ref="qrCode"></div>

            <v-btn text @click="advanced = true" v-if="!advanced">
              <v-icon small class="mr-1">mdi-cog</v-icon>
              Avançado
            </v-btn>

            <v-btn class="mt-7" large depressed style="width: 200px;" rounded dark color="#00C57E" @click="download()">Baixar</v-btn>
          </div>
        </div>
        <div v-if="advanced" style="width: 60%;" class="d-flex flex-column align-center">
          <h3>Customize abaixo o seu QR Code</h3>
          <div class="mt-2 d-flex justify-center">
            <div style="max-width: 400px">
              <v-row>
                <v-col md="6">
                  <v-select
                    v-if="logo !== 'Carregar logo'"
                    dense
                    v-model="logo"
                    label="Logo"
                    :items="['Padrão', 'Sem logo', 'Carregar logo']"
                    outlined
                    hide-details
                  ></v-select>
                  <v-file-input
                    v-else
                    dense
                    accept="image/png, image/jpeg, image/bmp, image/svg"
                    clearable
                    v-model="logoFile"
                    @clear="logo = 'Padrão'"
                    label="Logo"
                    placeholder="Clique para inserir"
                    outlined
                    prepend-inner-icon="mdi-image"
                    prepend-icon=""
                    hide-details
                  ></v-file-input>
                </v-col>
                <v-col md="6">
                  <v-select
                    dense
                    v-model="options.dotsOptions.type"
                    label="Pontos internos"
                    :items="[
                      { text: 'Quadrado', value: 'squared' },
                      { text: 'Ponto', value: 'dots' },
                      { text: 'Arredondado', value: 'extra-rounded' }
                    ]"
                    outlined
                    hide-details
                  >
                    <template v-slot:append-outer>
                      <v-menu offset-x :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                          <div v-on="on" class="tag-color" :style="`background-color: ${options.dotsOptions.color}`"></div>
                        </template>
                        <v-card flat>
                          <v-color-picker v-model="options.dotsOptions.color" mode="hexa"></v-color-picker>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <v-select
                    dense
                    v-model="options.cornersSquareOptions.type"
                    label="Pontos extremos"
                    :items="[
                      { text: 'Quadrado', value: 'square' },
                      { text: 'Redondo', value: 'dot' },
                      { text: 'Arredondado', value: 'extra-rounded' }
                    ]"
                    outlined
                    hint="Parte externa"
                    persistent-hint
                  >
                    <template v-slot:append-outer>
                      <v-menu offset-x :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                          <div v-on="on" class="tag-color" :style="`background-color: ${options.cornersSquareOptions.color}`"></div>
                        </template>
                        <v-card flat>
                          <v-color-picker v-model="options.cornersSquareOptions.color" mode="hexa"></v-color-picker>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-select>
                </v-col>
                <v-col md="6">
                  <v-select
                    dense
                    v-model="options.cornersDotOptions.type"
                    label="Pontos extremos"
                    :items="[
                      { text: 'Quadrado', value: 'square' },
                      { text: 'Rendondo', value: 'dot' }
                    ]"
                    outlined
                    hint="Parte interna"
                    persistent-hint
                  >
                    <template v-slot:append-outer>
                      <v-menu offset-x :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                          <div v-on="on" class="tag-color" :style="`background-color: ${options.cornersDotOptions.color}`"></div>
                        </template>
                        <v-card flat>
                          <v-color-picker v-model="options.cornersDotOptions.color" mode="hexa"></v-color-picker>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </div>
          </div>
          <h3 class="mt-5">Aplique UTMs no seu QR Code</h3>
          <div class="mt-2 d-flex justify-center">
            <div style="max-width: 400px">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    persistent-hint
                    dense
                    outlined
                    label="Origem da campanha"
                    v-model="utms.source"
                    hint="Recomendado: QRCode"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    persistent-hint
                    dense
                    outlined
                    label="Meio da campanha"
                    v-model="utms.medium"
                    hint="Ex.: banner, cartaz, video, live"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    dense
                    persistent-hint
                    outlined
                    label="Nome da campanha"
                    v-model="utms.campaign"
                    hint="Ex: produto, slogan"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    dense
                    persistent-hint
                    outlined
                    label="Conteúdo do Ads (Opcional)"
                    v-model="utms.content"
                    hint="Diferencie os QR Codes"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import QRCodeStyling from 'qr-code-styling'
import qs from 'qs'

export default {
  props: ['value', 'url'],
  data () {
    const options = {
      width: 275,
      height: 275,
      type: 'svg',
      data: '',
      image: '/img/qrcode-logo.svg',
      margin: 5,
      qrOptions: {
        typeNumber: 0,
        mode: 'Byte',
        errorCorrectionLevel: 'Q'
      },
      imageOptions: {
        hideBackgroundDots: false,
        imageSize: 0.4,
        margin: 0,
        crossOrigin: 'anonymous',
      },
      dotsOptions: {
        color: '#000000',
        type: 'squared'
      },
      backgroundOptions: {
        color: 'transparent'
      },
      cornersSquareOptions: {
        color: '#000000',
        type: 'square'
      },
      cornersDotOptions: {
        color: '#000000',
        type: 'square'
      }
    }

    return {
      format: 'SVG',
      logo: 'Padrão',
      logoFile: null,
      advanced: false,
      loading: false,
      qrCode: new QRCodeStyling(options),
      options,
      utms: {
        id: '',
        source: 'QRCode',
        medium: '',
        campaign: '',
        content: '',
        term: ''
      }
    }
  },
  computed: {
    link () {
      const query = {}

      if (this.utms.id) {
        query.utm_id = this.escapeSpace(this.utms.id)
      }

      if (this.utms.source) {
        query.utm_source = this.escapeSpace(this.utms.source)
      }

      if (this.utms.medium) {
        query.utm_medium = this.escapeSpace(this.utms.medium)
      }

      if (this.utms.campaign) {
        query.utm_campaign = this.escapeSpace(this.utms.campaign)
      }

      if (this.utms.term) {
        query.utm_term = this.escapeSpace(this.utms.term)
      }

      if (this.utms.content) {
        query.utm_content = this.escapeSpace(this.utms.content)
      }

      return `${this.url}?${qs.stringify(query)}`
    }
  },
  mounted () {
    this.qrCode.append(document.getElementById('qr-code'))
  },
  watch: {
    options: {
      deep: true,
      handler: function () {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => this.qrCode.update(this.options), 100)
      }
    },
    link: {
      immediate: true,
      handler: function (link) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => this.options.data = link, 500)
      }
    },
    logo: function (logo) {
      if (logo === 'Padrão') {
        this.options.image = '/img/qrcode-logo.svg'
      } else if (logo === 'Sem logo') {
        this.options.image = null
      } else if (logo === 'Carregar logo') {
        this.options.image = null
      }
    },
    logoFile: function (logoFile) {
      this.options.image = URL.createObjectURL(logoFile)
    },
    format: function (format) {
      if (format === 'JPEG') {
        this.options.backgroundOptions.color = '#FFFFFF'
      }
    }
  },
  methods: {
    escapeSpace (str) {
      return (str || '').replace(/\s/g, '_')
    },
    async save () {
      if (!this.form.name) {
        return false
      }

      this.loading = true
      try {
        await this.$store.dispatch('projects/store', {
          ...this.form,
          pixels: this.form.pixels.map(item => item.id)
        })
        this.form = {
          name: '',
          pixels: []
        }
      } catch (e) {
        alert('Oops! Ocorreu um erro ao criar o seu projeto.')
      }
      this.loading = false

      this.$emit('input', false)
    },
    download () {
      const qrCode = new QRCodeStyling({
        ...this.options,
        width: 512,
        height: 512
      })

      qrCode.download({ name: 'qrcode', extension: this.format.toLowerCase() })
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-color {
  height: 37px;
  width: 37px;
  border-radius: 5px;
  background-color: black;
  position: relative;
  top: -6px;
  cursor: pointer;
}
</style>
